module.exports = ".fixed-overlay {\n  position: fixed;\n  bottom: 25px;\n  right: 0;\n  padding: 0.5rem;\n  padding-right: 50px;\n}\n"